// extracted by mini-css-extract-plugin
module.exports = {"linkList":"styles_linkList__2tF15"};